module.exports = __webpack_public_path__ + "static/working_in_partnership_with_parents.4aa32a84.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/policies/working_in_partnership_with_parents.pdf
// module id = 339
// module chunks = 177890977751730